export default "__VITE_ASSET__D1INcHMo__"